import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const addEmployeeGroup = (orgId: number, name: string) =>
  createGenericDispatcher<{ employeeGroup: EmployeeGroup }>({
    name: 'ADD_EMPLOYEE_GROUP',
    loadFunction: () =>
      Api.post(`/employee-groups?orgId=${orgId}`, {
        body: JSON.stringify({ name }),
      }),
    args: { orgId, name },
  });
